import Auth from '@/infrastructure/api/helper/Auth';
import {在庫調整検索依頼型, 在庫調整検索結果型, 在庫調整登録依頼型} from '@/type/adjustment/records/register/在庫調整登録';

export default {

    async 在庫調整一覧を取得する(在庫調整検索依頼: 在庫調整検索依頼型): Promise<在庫調整検索結果型> {
        const auth = new Auth();
        const response = await auth.post('/api/adjustment/list', 在庫調整検索依頼);
        const 在庫調整検索結果 = response.data;
        return 在庫調整検索結果;
    },

    async 在庫調整を登録する(在庫調整登録依頼: 在庫調整登録依頼型): Promise<void> {
        const auth = new Auth();
        await auth.post('/api/adjustment/register', 在庫調整登録依頼);
    },

};
